import { render } from "./BaseSidebarEditor.vue?vue&type=template&id=2969f2c2"
import script from "./BaseSidebarEditor.vue?vue&type=script&lang=js"
export * from "./BaseSidebarEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__